(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4747],{

/***/ 26460:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evry",
      function () {
        return __webpack_require__(42782);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54171:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/dawn-logo.d6e5226b.svg","height":32,"width":107});

/***/ }),

/***/ 42385:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/navbar-get-started.e695b23d.svg","height":64,"width":177});

/***/ }),

/***/ 504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* reexport */ Link; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Link/Link.tsx




/* istanbul ignore file */ // @ts-nocheck
// WARNING: DO NOT EDIT THIS FILE UNLESS YOU ARE SURE ABOUT WHAT YOU ARE DOING. MIGHT CAUSE UNEXPECTED LINK ISSUES


var Link = function(_param) {
    var children = _param.children, href = _param.href, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "href"
    ]);
    var router = (0,next_router.useRouter)();
    var hrefObj = {
        pathname: href.pathname || "",
        query: {}
    };
    if (typeof href === "string") {
        hrefObj.pathname = href;
    }
    if (href.query) {
        hrefObj.query = href.query;
    }
    var queries = {};
    Object.entries(router.query).forEach(function(q) {
        if (q[0].toLowerCase().includes("utm") || q[0].toLowerCase().includes("gclid")) {
            queries[q[0]] = q[1];
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        href: {
            pathname: hrefObj.pathname || href,
            query: (0,_object_spread/* default */.Z)({}, queries, hrefObj.query)
        }
    }, props), {
        children: children
    }));
};


;// CONCATENATED MODULE: ./components/Link/index.ts



/***/ }),

/***/ 45501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ Aggregates; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/page-sections/Aggregates/Aggregates.tsx

function Aggregates() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-7xl pt-22 xl:pt-30",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center xl:flex-row xl:space-x-8 space-y-22 xl:space-y-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center xl:w-72",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-transparent bg-clip-text bg-gradient-to-br from-dawnOrange-500 to-dawnPurple-500 text-6.25xl leading-18 xl:text-7xl font-bold",
                                    children: "75%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "xl:px-6 mt-2 md:mt-6 text-base text-center xl:text-xl max-w-[176px] xl:max-w-none",
                                    children: "less time needed to fall asleep"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center xl:w-72",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-transparent bg-clip-text bg-gradient-to-br from-dawnOrange-500 to-dawnPurple-500 text-6.25xl leading-18 xl:text-7xl font-bold",
                                    children: "80%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-2 md:mt-6 text-base text-center xl:text-xl max-w-[176px] xl:max-w-none",
                                    children: "less time awake in the middle of the night"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center xl:w-72",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-transparent bg-clip-text bg-gradient-to-br from-dawnOrange-500 to-dawnPurple-500 text-6.25xl leading-18 xl:text-7xl font-bold",
                                    children: "60%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "px-6 mt-2 md:mt-6 text-base text-center xl:text-xl max-w-[176px] xl:max-w-none",
                                    children: "decrease in ISI symptoms"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center xl:w-72",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-transparent bg-clip-text bg-gradient-to-br from-dawnOrange-500 to-dawnPurple-500 text-6.25xl leading-18 xl:text-7xl font-bold",
                                    children: "90 min"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "xl:px-10 mt-2 md:mt-6 text-base text-center xl:text-xl max-w-[176px] xl:max-w-none",
                                    children: "increase in total sleep time"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "px-10 mt-16 mb-6 text-base italic text-center xl:text-lg font-inter text-dawnDark-400",
                    children: "Based on users who followed the program for 1 month or more"
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/page-sections/Aggregates/index.ts



/***/ }),

/***/ 42782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ EveryCollab; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js
var popover = __webpack_require__(86215);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Link/index.ts + 1 modules
var components_Link = __webpack_require__(504);
;// CONCATENATED MODULE: ./public/evry-collab/dawn-evry-logo.svg
/* harmony default export */ var dawn_evry_logo = ({"src":"/_next/static/media/dawn-evry-logo.034568af.svg","height":32,"width":235});
;// CONCATENATED MODULE: ./modules/evry-collab/Navbar/NavbarLogo.tsx




function NavbarLogo(param) {
    var _width = param.width, width = _width === void 0 ? 235 : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Link/* Link */.r, {
        href: "/evry",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "aria-label": "Back to main page",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: dawn_evry_logo,
                alt: "Dawn logo",
                width: width
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./modules/evry-collab/Navbar/NavbarLinks.tsx




function NavbarLinksDefault(param) {
    var linkClassName = param.linkClassName, linkOnClick = param.linkOnClick;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Link/* Link */.r, {
                href: "/faq",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: classnames_default()(linkClassName, {
                        "font-bold": router.pathname.startsWith("/faq")
                    }),
                    children: "FAQS"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Link/* Link */.r, {
                href: "/blog",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: classnames_default()(linkClassName, {
                        "font-bold": router.pathname.startsWith("/blog")
                    }),
                    children: "Blog"
                })
            })
        ]
    });
}
var navbarLinksAboutPathnames = (/* unused pure expression or super */ null && ([
    "/company",
    "/reviews",
    "/employers"
]));
function NavbarLinksAbout(param) {
    var linkClassName = param.linkClassName, linkOnClick = param.linkOnClick;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Link, {
                href: "/company",
                children: /*#__PURE__*/ _jsx("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Company"
                })
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: "/reviews",
                children: /*#__PURE__*/ _jsx("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Reviews"
                })
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: "/employers",
                children: /*#__PURE__*/ _jsx("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Enterprise"
                })
            })
        ]
    });
}
var navbarLinksPagesPathnames = [
    "/insomnia-criteria",
    "/cbt-i-app",
    "/insomnia-cure",
    "/sleep-therapy"
];
function NavbarLinksPages(param) {
    var linkClassName = param.linkClassName, linkOnClick = param.linkOnClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Link/* Link */.r, {
                href: "/insomnia-criteria",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Insomnia Criteria"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Link/* Link */.r, {
                href: "/cbt-i-app",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "CBT-I App"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Link/* Link */.r, {
                href: "/sleep-therapy",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Sleep Therapy"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Link/* Link */.r, {
                href: "/primary-insomnia",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Primary Insomnia"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Link/* Link */.r, {
                href: "/chronic-insomnia",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Chronic Insomnia"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Link/* Link */.r, {
                href: "/insomnia-test",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Insomnia Test"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure = __webpack_require__(6512);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(84539);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/index.js + 230 modules
var esm = __webpack_require__(63153);
;// CONCATENATED MODULE: ./modules/evry-collab/Navbar/NavbarMenuMobileDisclosure.tsx





function NavbarMenuMobileDisclosure(param) {
    var title = param.title, children = param.children, linkPathnames = param.linkPathnames;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pb-6 border-b border-white border-opacity-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
            children: function(param) {
                var open = param.open;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                            className: "flex items-center justify-between w-full hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-dawnDark-500 focus-visible:ring-opacity-75",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classnames_default()("text-sm tracking-widest text-white uppercase", "".concat(open || linkPathnames.includes(router.asPath) ? "font-bold" : "font-medium")),
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronUpIcon */.g8U, {
                                    className: "".concat(open ? "" : "transform rotate-180", " w-5 h-5")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                            show: open,
                            enter: "transition duration-100 ease-out",
                            enterFrom: "transform scale-95 opacity-0",
                            enterTo: "transform scale-100 opacity-100",
                            leave: "transition duration-75 ease-out",
                            leaveFrom: "transform scale-100 opacity-100",
                            leaveTo: "transform scale-95 opacity-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                static: true,
                                className: "flex flex-col mt-8 mb-4 space-y-8",
                                children: children
                            })
                        })
                    ]
                });
            }
        })
    });
}

;// CONCATENATED MODULE: ./modules/evry-collab/Navbar/NavbarMenuMobile.tsx








function NavbarMenuMobile(param) {
    var ctaInHeader = param.ctaInHeader, ctaText = param.ctaText;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    (0,react.useEffect)(function() {
        document.body.classList.toggle("prevent-body-scroll", isOpen);
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
        children: function(param) {
            var open = param.open;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("flex items-center justify-between px-6 py-5", {
                    "bg-dawnDark-500 fixed inset-x-0 z-20": isOpen
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLogo, {
                        width: 180
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("pb-2", {
                            hidden: !ctaInHeader
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Link/* Link */.r, {
                            href: "/questionnaire/signup-evry-v1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center whitespace-nowrap",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    onClick: function() {
                                        return setIsOpen(false);
                                    },
                                    className: "flex items-center justify-center flex-1 max-w-md px-4 py-2 text-sm font-medium tracking-widest text-white uppercase whitespace-nowrap getStartedNavBar bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500 rounded-3xl",
                                    children: ctaText !== null && ctaText !== void 0 ? ctaText : "Get started"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                className: "focus:outline-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: function() {
                                        return setIsOpen(function(isOpen) {
                                            return !isOpen;
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        className: "w-6 h-6",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        children: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M6 6L18 18M6 18L18 6L6 18Z",
                                            stroke: "white",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M3.9751 17.975H19.9751M3.9751 5.97501H19.9751H3.9751ZM3.9751 11.975H19.9751H3.9751Z",
                                            stroke: "white",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                                static: true,
                                className: classnames_default()("absolute inset-x-0 min-h-screen h-full z-20 bg-dawnDark-500", {
                                    hidden: !isOpen
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col justify-between h-full px-6 overflow-y-scroll",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col pt-6 space-y-6 text-sm text-white",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarMenuMobileDisclosure, {
                                                    title: "How it Works",
                                                    linkPathnames: navbarLinksPagesPathnames,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLinksPages, {
                                                        linkOnClick: function() {
                                                            return setIsOpen(false);
                                                        },
                                                        linkClassName: "font-inter text-base font-normal"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLinksDefault, {
                                                    linkOnClick: function() {
                                                        return setIsOpen(false);
                                                    },
                                                    linkClassName: "pb-6 border-b border-white border-opacity-10 uppercase tracking-widest font-medium"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()("mt-6 mb-20", {
                                                hidden: ctaInHeader
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Link/* Link */.r, {
                                                href: "/questionnaire/signup-evry-v1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex justify-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        onClick: function() {
                                                            return setIsOpen(false);
                                                        },
                                                        className: "flex items-center justify-center flex-1 max-w-md px-8 py-4 text-sm font-medium tracking-widest text-white uppercase getStartedNavBar bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500 rounded-3xl",
                                                        children: "Get started"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/usePopper.js + 53 modules
var usePopper = __webpack_require__(66441);
;// CONCATENATED MODULE: ./modules/evry-collab/Navbar/NavbarMenuDesktopDropdown.tsx








function NavbarMenuDesktopDropdown(param) {
    var title = param.title, children = param.children, linkPathnames = param.linkPathnames;
    var router = (0,next_router.useRouter)();
    var popperElementRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), buttonElement = ref[0], setButtonElement = ref[1];
    var ref1 = (0,react.useState)(null), popperElement = ref1[0], setPopperElement = ref1[1];
    var ref2 = (0,react.useState)(null), arrowElement = ref2[0], setArrowElement = ref2[1];
    var ref3 = (0,usePopper/* usePopper */.D)(buttonElement, popperElement, {
        placement: "bottom-start",
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement
                }
            },
            {
                name: "offset",
                enabled: true,
                options: {
                    offset: [
                        0,
                        5
                    ]
                }
            }, 
        ]
    }), styles = ref3.styles, attributes = ref3.attributes;
    // Hover logic
    var ref4 = (0,react.useState)(false), openDropdown = ref4[0], setOpenDropdown = ref4[1];
    var ref5 = (0,react.useState)(false), mouseOverButton = ref5[0], setMouseOverButton = ref5[1];
    var ref6 = (0,react.useState)(false), mouseOverMenu = ref6[0], setMouseOverMenu = ref6[1];
    var timeoutDuration = 50;
    var timeoutButton;
    var timeoutMenu;
    var onMouseEnterButton = function() {
        clearTimeout(timeoutButton);
        setOpenDropdown(true);
        setMouseOverButton(true);
    };
    var onMouseLeaveButton = function() {
        timeoutButton = setTimeout(function() {
            return setMouseOverButton(false);
        }, timeoutDuration);
    };
    var onMouseEnterMenu = function() {
        clearTimeout(timeoutMenu);
        setMouseOverMenu(true);
    };
    var onMouseLeaveMenu = function() {
        timeoutMenu = setTimeout(function() {
            return setMouseOverMenu(false);
        }, timeoutDuration);
    };
    var show = openDropdown && (mouseOverMenu || mouseOverButton);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                ref: setButtonElement,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: function() {
                        return setOpenDropdown(!openDropdown);
                    },
                    onMouseEnter: onMouseEnterButton,
                    onMouseLeave: onMouseLeaveButton,
                    className: classnames_default()("px-8 leading-4 tracking-widest text-white uppercase h-full py-4", "".concat(show || linkPathnames.includes(router.asPath) ? "font-bold" : "font-medium")),
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: popperElementRef,
                style: styles.popper
            }, attributes.popper), {
                className: "z-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                    show: show,
                    unmount: false,
                    enter: "transition ease-out duration-100",
                    enterFrom: "transform opacity-0 scale-95",
                    enterTo: "transform opacity-100 scale-100",
                    leave: "transition ease-in duration-75",
                    leaveFrom: "transform opacity-100 scale-100",
                    leaveTo: "transform opacity-0 scale-95",
                    beforeEnter: function() {
                        return setPopperElement(popperElementRef.current);
                    },
                    afterLeave: function() {
                        return setPopperElement(null);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Panel */.J.Panel, {
                        onMouseEnter: onMouseEnterMenu,
                        onMouseLeave: onMouseLeaveMenu,
                        unmount: false,
                        className: "rounded bg-dawnDark-550",
                        onClick: function() {
                            return setOpenDropdown(!openDropdown);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: setArrowElement,
                                style: styles.arrow,
                                className: "before:rounded before:-top-2 before:w-5 before:h-5 before:transform before:rotate-45 before:bg-dawnDark-550 before:absolute"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col p-4 text-white",
                                children: children
                            })
                        ]
                    })
                })
            }))
        ]
    });
}

// EXTERNAL MODULE: ./public/navbar-get-started.svg
var navbar_get_started = __webpack_require__(42385);
;// CONCATENATED MODULE: ./modules/evry-collab/Navbar/NavbarMenuDesktop.tsx







function NavbarMenuDesktop() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-between flex-1 px-10 py-5 max-w-9xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLogo, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarMenuDesktopDropdown, {
                            title: "How it Works",
                            linkPathnames: navbarLinksPagesPathnames,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLinksPages, {
                                linkClassName: "px-4 py-2 text-lg leading-8 rounded font-inter whitespace-nowrap hover:bg-dawnDark-400 hover:bg-opacity-70"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-medium leading-4 tracking-widest text-white uppercase",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLinksDefault, {
                                linkClassName: "px-8 py-4"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Link/* Link */.r, {
                            href: "/questionnaire/signup-evry-v1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "ml-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: navbar_get_started/* default */.Z,
                                    alt: "Get started"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./modules/evry-collab/Navbar/Navbar.tsx



function Navbar(param) {
    var className = param.className, ctaInHeader = param.ctaInHeader, ctaText = param.ctaText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block lg:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarMenuMobile, {
                    ctaInHeader: ctaInHeader,
                    ctaText: ctaText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden lg:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarMenuDesktop, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/page-sections/Testimonials/index.ts + 1 modules
var Testimonials = __webpack_require__(39021);
;// CONCATENATED MODULE: ./modules/evry-collab/FrequentlyAskedQuestions.tsx



var frequentlyAskedQuestionsAndAnwesData = [
    {
        question: "How does sleep coaching work?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Dawn pairs you with a sleep coach that is available over chat within the app. Your coach will answer any questions you have and personalize the program for you based on your needs. Our coaches are trained in CBT-I and have helped patients adhere to a program and improve their sleep."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Having a coach also ensures accountability which is the most important part of a behavioral change program. Our coaches will motivate, hold you accountable and ensure that you have success and meet your goals."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "You will have 30 minute weekly video sessions and 24x7 text access to your coach!"
                })
            ]
        })
    },
    {
        question: "What kind of time commitment does Dawn require?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Most of our patients use Dawn 5 minutes a day and stick to the program for 3 months."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Dawn requires that you are able to keep a consistent wake-up time for at least 4 weeks. If you are planning any international travel, we recommend trying Dawn after you are over jet lag."
                })
            ]
        })
    },
    {
        question: "How much does Dawn cost?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Dawn is free for Evry Health members!"
            })
        })
    },
    {
        question: "Can I use Dawn even if I already have a therapist?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes! Please tell your therapist that you plan to try a CBT-I program. Many of them are extremely supportive of behavioral change programs."
            })
        })
    },
    {
        question: "Do I need a smartphone to use Dawn?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Dawn is currently available on Android and iOS devices. This includes iPads and Android tablets."
            })
        })
    }, 
];
var FrequentlyAskedQuestionAndAnswer = function(param) {
    var index = param.index, isExpanded = param.isExpanded, setExpandedIndex = param.setExpandedIndex, question = param.question, answer = param.answer;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        onClick: function() {
            return setExpandedIndex(isExpanded ? -1 : index);
        },
        className: "py-6 text-left text-white border-b border-white md:py-8 border-opacity-10 last:border-none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("flex items-center justify-between w-full space-x-4", {
                    "mb-4": isExpanded
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-xl font-medium leading-6 text-left font-inter md:text-2xl",
                        children: question
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            width: "17",
                            height: "10",
                            viewBox: "0 0 17 10",
                            fill: "none",
                            children: [
                                isExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M16.5 9L8.5 0.999998L0.5 9",
                                    stroke: "url(#paint0_linear)",
                                    strokeMiterlimit: "10"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M0.5 1L8.5 9L16.5 1",
                                    stroke: "url(#paint0_linear)",
                                    strokeMiterlimit: "10"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                        id: "paint0_linear",
                                        x1: "0.499999",
                                        y1: "9",
                                        x2: "4.68789",
                                        y2: "-3.09122",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                stopColor: "#FF8F5B"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                offset: "1",
                                                stopColor: "#536DE2"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mr-6 overflow-hidden text-base md:text-xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col space-y-8 font-inter",
                    children: answer
                })
            })
        ]
    });
};
function FrequentlyAskedQuestions() {
    var ref = (0,react.useState)(-1), expandedIndex = ref[0], setExpandedIndex = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "flex justify-center py-12 mx-8 md:py-24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex-1 max-w-3.5xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-3xl font-semibold text-left md:text-center text-white md:text-5xl",
                    children: "Frequently Asked Questions"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col mt-14",
                    children: frequentlyAskedQuestionsAndAnwesData.map(function(data, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequentlyAskedQuestionAndAnswer, {
                            index: index,
                            isExpanded: index === expandedIndex,
                            setExpandedIndex: setExpandedIndex,
                            question: data.question,
                            answer: data.answer
                        }, index);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(15445);
// EXTERNAL MODULE: ./components/page-sections/Aggregates/index.ts + 1 modules
var Aggregates = __webpack_require__(45501);
;// CONCATENATED MODULE: ./public/evry-collab/hero-app-screenshot.png
/* harmony default export */ var hero_app_screenshot = ({"src":"/_next/static/media/hero-app-screenshot.36200943.png","height":1559,"width":922,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAM1BMVEUpLTRKSk49QEVAToEqLjI6PUISFh4zNj4uMjYlKi5FSVBGODVWZ6shJSwSFx88RW42PluekwY9AAAADXRSTlP+S+jQ0GD9/Mb38f3ZusxPxQAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAACtJREFUeJwFwYcBACAMwzAzU0aA/69FQnYkfLoDARlsT9C6G6RXkKHSYoz4HPwBKOJ8VH4AAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./modules/employers/DawnFeatures.tsx + 4 modules
var DawnFeatures = __webpack_require__(34102);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/page-sections/InThePress/index.ts + 5 modules
var InThePress = __webpack_require__(33732);
;// CONCATENATED MODULE: ./pages/evry.tsx













function EveryCollab() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Overcome Insomnia With CBT-I & Sleep Coaching \u2014 Sleep App | Dawn Health"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Struggling with insomnia? Ditch the pills and cure your insomnia for good with Dawn's proven online CBT-I app. Let our sleep experts get you back to sleep."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "facebook-domain-verification",
                        content: "lypvevgg0c2g46jzbubi2frb5kd96o"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "initial-scale=1.0, width=device-width"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "overflow-x-hidden bg-dawnDark-700",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                color: "purple",
                                scale: 7,
                                opacity: 0.25,
                                left: "-50rem"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                color: "orange",
                                scale: 8,
                                opacity: 0.15,
                                left: "-60rem",
                                top: "10rem"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                color: "purple",
                                scale: 7,
                                opacity: 0.25,
                                right: "-30rem",
                                top: "-20rem"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                color: "orange",
                                scale: 7,
                                opacity: 0.1,
                                right: "-40rem",
                                top: "-2rem"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                className: "flex md:justify-center pt-[72px] px-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col md:flex-row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                    className: "text-white font-semibold text-5xl leading-14 md:leading-18 md:text-5.5xl md:pt-16 pr-[72px]",
                                                    children: [
                                                        "Start Sleeping.",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        " Defeat Insomnia."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "mt-4 space-y-4 text-white md:mt-8",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            className: "flex content-center space-x-4",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                        width: "24",
                                                                        height: "24",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M4 12L10 18L20 6",
                                                                            stroke: "#FF8F5B",
                                                                            strokeWidth: "2",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "text-base md:text-xl font-inter",
                                                                    children: "Covered by Evry Health at no cost to you"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            className: "flex items-center space-x-4",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                        width: "24",
                                                                        height: "24",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M4 12L10 18L20 6",
                                                                            stroke: "#FF8F5B",
                                                                            strokeWidth: "2",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "text-base md:text-xl font-inter",
                                                                    children: "Completely confidental"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-8 md:mt-12",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/questionnaire/signup-evry-v1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "block px-8 py-4 text-sm font-medium tracking-widest text-center text-white uppercase rounded-full md:py-6 md:inline-block bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500 md:text-base md:leading-4",
                                                            children: "Join Dawn for Free"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-14 md:mt-0 overflow-hidden h-[370px] md:h-[590px] md:w-[461px] w-[295px] mx-auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: hero_app_screenshot,
                                                alt: ""
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Aggregates/* Aggregates */._, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DawnFeatures/* default */.Z, {
                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "Digital care that starts and ends",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                    className: "hidden md:inline-block"
                                }),
                                " with you"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials/* Testimonials */.H, {
                        showTitle: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-12 -mt-16",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InThePress/* InThePressLogos */.P, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequentlyAskedQuestions, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                ]
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9122,5329,5430,1421,2232,3704,9774,2888,179], function() { return __webpack_exec__(26460); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);